import Navigation from "./Navigation";
import { Button } from "@material-ui/core";
import SendIcon from '@material-ui/icons/Send';

export default function StandardNavigation(props: {
  children: React.ReactChild | React.ReactChild[];
  createDocument: () => {} | any;
  jsonIsValid: boolean;
}) {
  const createDocumentButtonRight = (
    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
      <Button
        onClick={() => {
          props.createDocument();
        }}
        color="primary"
        variant="contained"
        disabled={!props.jsonIsValid}
        startIcon={<SendIcon />}
      >
        Send Request
      </Button>
    </div>
  );

  return (
    <Navigation
      disablePermanentDrawer
      appBarChildrenWithoutPermanentDrawer={createDocumentButtonRight}
    >
      {props.children}
    </Navigation>
  );
}
